/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectFieldSettingsControllerFindForScopeQueryResponse, ProjectFieldSettingsControllerFindForScopePathParams, ProjectFieldSettingsControllerFindForScope401, ProjectFieldSettingsControllerFindForScope403 } from "../../models/projectFieldSettingsController/ProjectFieldSettingsControllerFindForScope";

function getProjectFieldSettingsControllerFindForScopeUrl(scopeId: ProjectFieldSettingsControllerFindForScopePathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/scopes/${scopeId}/project-field-settings` as const }  
  return res
}

/**
 * @summary Get the resolved project field settings
 * {@link /api/v1/scopes/:scopeId/project-field-settings}
 */
export async function projectFieldSettingsControllerFindForScope(scopeId: ProjectFieldSettingsControllerFindForScopePathParams["scopeId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectFieldSettingsControllerFindForScopeQueryResponse, ResponseErrorConfig<ProjectFieldSettingsControllerFindForScope401 | ProjectFieldSettingsControllerFindForScope403>, unknown>({ method : "GET", url : getProjectFieldSettingsControllerFindForScopeUrl(scopeId).url.toString(), ... requestConfig })  
  return res.data
}